'use strict';

export * from "./font.js";
export * from "./platform.js";
//# sourceMappingURL=index.js.map